import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MtnaFormFieldWrappersModule, MtnaInlineEditorControlsModule } from '@mtna/core-angular';

import { RdsCRichTextEditorComponent } from './rich-text-editor.component';

@NgModule({
  imports: [CommonModule, CKEditorModule, FormsModule, MtnaFormFieldWrappersModule, MtnaInlineEditorControlsModule],
  exports: [RdsCRichTextEditorComponent],
  declarations: [RdsCRichTextEditorComponent],
})
export class RdsCRichTextEditorModule {}
